import React from 'react';
import { motion } from 'framer-motion';
import { PAIN_POINTS } from './salesData';
export function PainSection() {
  return <section className="bg-ivory py-12 sm:py-16" data-id="element-157" data-mp="38wlv6wefoyjb">
      <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-158" data-mp="2uy5nb24u51zl">
        <h2 className="font-display text-[1.7rem] font-semibold leading-tight text-charcoal sm:text-[2.4rem]" data-id="element-159" data-mp="2uxm7ps2nqpoq">
          Si esto te pasa, no es por falta de talento
        </h2>
        <p className="mx-auto mt-4 max-w-2xl font-sans text-sm leading-relaxed text-charcoal/70 sm:text-base" data-id="element-160" data-mp="2l7aypr449qaz">
          Sabés enseñar, acompañar y transformar personas. Lo que todavía no está funcionando es la
          forma en que tu Instagram comunica y convierte ese valor.
        </p>

        <ul className="mx-auto mt-7 grid gap-2 text-left sm:grid-cols-2" data-id="element-161" data-mp="2gaau7kmx0vlz">
          {PAIN_POINTS.map((p, i) => <motion.li key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.35,
          delay: i * 0.04
        }} className="flex items-start gap-2.5 rounded-lg border border-stone bg-sand/60 px-3.5 py-2.5" data-id="element-162" data-mp="22asz6nj10m46" data-mpi={i}>
              <span className="mt-[7px] h-1.5 w-1.5 shrink-0 rounded-full bg-gold-deep/60" aria-hidden data-id="element-163" data-mp="5erhip78mkyp" />
              <span className="font-sans text-[0.82rem] leading-snug text-charcoal/75" data-id="element-164" data-mp="ewrenvadzep">{p}</span>
            </motion.li>)}
        </ul>

        <p className="mt-8 font-display text-xl font-semibold italic leading-snug text-charcoal sm:text-2xl" data-id="element-165" data-mp="33y7wxl3p2gaz">
          El problema no es lo que hacés. Es que tu Instagram todavía no está funcionando como un
          sistema comercial.
        </p>
      </div>
    </section>;
}